import {buildCloudinaryImageUrl} from '../../../../../../utils/CloudinaryImageUrl';
/* ════════════════════════════════════════════
   MOBILE CART MODAL
════════════════════════════════════════════ */
const fmt = (n) => '$' + Number(n).toFixed(2);
const SHIPPING_METHODS = [
  { id: 'standard', icon: '🛵', title: 'Entrega estándar', sub: 'Estimado: 40–60 min', price: 3.50 },
  { id: 'express', icon: '⚡', title: 'Entrega express', sub: 'Estimado: 20–30 min', price: 6.00 },
  { id: 'eco', icon: '🌿', title: 'Eco envío', sub: 'Estimado: 60–90 min', price: 2.00 },
];

const getItbmsLabel = (taxes = [], itbms = 0) => {
  const taxList = Array.isArray(taxes) ? taxes : [];
  const visibleTaxes = taxList.filter(tax => Number(tax?.total || 0) > 0);
  const sourceTaxes = visibleTaxes.length > 0 ? visibleTaxes : taxList;
  const percentages = [...new Set(
    sourceTaxes
      .map(tax => tax?.tax || tax?.percentage)
      .filter(Boolean)
  )];

  if (percentages.length === 1) return `ITBMS (${percentages[0]})`;
  if (percentages.length > 1 && Number(itbms || 0) > 0) return `ITBMS (${percentages.join(", ")})`;
  return "ITBMS";
};

export default function CartModal({
  items,
  deliveryMethod,
  shippingMethod,
  subtotal = 0,
  itbms = 0,
  shipCost = 0,
  total = 0,
  taxes = [],
  onClose
}) {

  const calculatedSubtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const calculatedShipCost = deliveryMethod === 'delivery' && shippingMethod
    ? (SHIPPING_METHODS.find(m => m.id === shippingMethod)?.price || 0) : 0;
  const displaySubtotal = Number(subtotal || calculatedSubtotal);
  const displayItbms = Number(itbms || 0);
  const displayShipCost = Number(shipCost || calculatedShipCost);
  const displayTotal = Number(total || (displaySubtotal + displayItbms + displayShipCost));
  const itbmsLabel = getItbmsLabel(taxes, displayItbms);

  return (
    <div className="ck-modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="ck-modal">
        <div className="ck-modal-header">
          <p className="ck-modal-title">Tu pedido</p>
          <button className="ck-modal-close" onClick={onClose}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div className="ck-modal-body">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.65rem', marginBottom: '1rem' }}>
            {items.map(item => (
              <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: '.85rem', padding: '.75rem .9rem', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)' }}>
                <div style={{ width: 48, height: 48, borderRadius: 10, overflow: 'hidden', background: 'var(--bg-2)', flexShrink: 0, position: 'relative' }}>
                  <img src={buildCloudinaryImageUrl({url:item.img, width: 300, quality: "auto", type: "image"})} alt={item.name} onError={e => e.target.style.opacity = 0} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <span style={{ position: 'absolute', top: -4, right: -4, width: 16, height: 16, borderRadius: '50%', background: 'var(--text)', color: 'white', fontSize: '.58rem', fontWeight: 700, display: 'grid', placeItems: 'center', border: '2px solid white' }}>{item.qty}</span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontSize: '.85rem', fontWeight: 500, color: 'var(--text)', marginBottom: 2 }}>{item.name}</p>
                  <p style={{ fontSize: '.7rem', color: 'var(--text-3)' }}>{item.desc}</p>
                </div>
                <span style={{ fontFamily: 'var(--font-serif)', fontSize: '.95rem', color: 'var(--text)', flexShrink: 0 }}>{fmt(item.price * item.qty)}</span>
              </div>
            ))}
          </div>
          <div style={{ height: 1, background: 'var(--border)', marginBottom: '.85rem' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.82rem', color: 'var(--text-2)', padding: '.2rem 0' }}>
              <span>Subtotal</span><span style={{ fontWeight: 500, color: 'var(--text)' }}>{fmt(displaySubtotal)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.82rem', color: 'var(--text-2)', padding: '.2rem 0' }}>
              <span>{itbmsLabel}</span><span style={{ fontWeight: 500, color: 'var(--text)' }}>{fmt(displayItbms)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.82rem', color: 'var(--text-2)', padding: '.2rem 0' }}>
              <span>Envío</span>
              <span style={{ fontWeight: 600, color: displayShipCost === 0 ? '#22c55e' : 'var(--brand)' }}>
                {deliveryMethod === 'pickup' ? 'Gratis' : displayShipCost > 0 ? fmt(displayShipCost) : '—'}
              </span>
            </div>
          </div>
        </div>
        <div className="ck-modal-footer">
          <div className="ck-modal-total-row">
            <span className="ck-modal-total-label">Total a pagar</span>
            <span className="ck-modal-total-val">{fmt(displayTotal)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
